import axios from "axios";
import { BaseAPI } from "./BaseAPI";
export class IdentifyAPI extends BaseAPI {

  //獲取啟動授權URL
  async getAuthorizationUrl(applicationNo, isApp = true) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/association-business/identity/${isApp}/getAuthorizationUrl?applicationNo=${applicationNo}` );
    return data;
  }

  // 校验识别是否成功
  async checkIdentity(applicationNo, confirmNo, isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/identity/${isApp}/checkAuthResult?applicationNo=${applicationNo}&confirmNo=${confirmNo}`);
    return data;
  }

  //获取多人识别地址
  async getMultipleAuthorizationUrl(applicationNo, participantEuids, isApp = true) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/association-business/identity/${isApp}/getMultipleAuthorizationUrl?applicationNo=${applicationNo}&participantEuids=${participantEuids}` );
    return data;
  }


}

export default new IdentifyAPI({
  prefix: '',
  path: '/mo/application',
});
